import { combineReducers } from 'redux';

import authReducer from './authReducer';
import clientReducer from './clientReducer';
import userReducer from './userReducer';
import rulesReducer from './rules/rulesSlice';
import townsReducer from './townsReducer';
import publicationsReducer from './publicationsReducer';
import toolboxReducer from './toolboxReducer';
import usersReducer from './usersReducer';
import customersReducer from './customersReducer';
import customerGroupsReducer from './customerGroupsReducer';
import customerHallsReducer from './customerHallsReducer';
import rolesReducer from './rolesReducer';
import signalsReducer from './signals/signalsSlice';
import categoriesReducer from './categories/categoriesSlice';
import badgesReducer from './badges/badgesSlice';

export default combineReducers({
  status: authReducer,
  me: userReducer,
  client: clientReducer,
  rules: rulesReducer,
  towns: townsReducer,
  publications: publicationsReducer,
  toolbox: toolboxReducer,
  users: usersReducer,
  customers: customersReducer,
  customerGroups: customerGroupsReducer,
  customerHalls: customerHallsReducer,
  roles: rolesReducer,
  signals: signalsReducer,
  categories: categoriesReducer,
  badges: badgesReducer,
});
